import { render, staticRenderFns } from "./liveIndex.vue?vue&type=template&id=42bbdb96&scoped=true&"
import script from "./liveIndex.vue?vue&type=script&lang=js&"
export * from "./liveIndex.vue?vue&type=script&lang=js&"
import style0 from "./liveIndex.vue?vue&type=style&index=0&id=42bbdb96&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bbdb96",
  null
  
)

export default component.exports